// Arabic strings for the catalogueStock area (master catalogue, stock points / linen / stock moves, tag generation console).
// Keyed by the English source text; {name} placeholders stay as-is.
export default {
  "Photo of {name}": "صورة {name}",
  "Brand library switched on. Brand standard items can now only be changed by group administrators.": "تم تشغيل مكتبة العلامة التجارية. لا يمكن الآن تعديل أصناف معيار العلامة إلا من قِبل مسؤولي المجموعة.",
  "Brand library switched off. Brand standard items can be edited like any other group item.": "تم إيقاف مكتبة العلامة التجارية. يمكن تعديل أصناف معيار العلامة مثل أي صنف آخر في المجموعة.",
  "Brand library": "مكتبة العلامة التجارية",
  "On": "مفعّلة",
  "Off": "متوقفة",
  "{property} uses your group's catalogue. Add items only your property needs as local items; brand standard items are set by your group.": "يستخدم {property} كتالوج مجموعتك. أضف الأصناف التي يحتاجها عقارك فقط كأصناف محلية؛ أما أصناف معيار العلامة فتحددها مجموعتك.",
  "Your group catalogue is shared by every property. Mark the items every hotel must use as brand standard; properties can still add their own local items.": "كتالوج مجموعتك مشترك بين جميع العقارات. حدّد الأصناف التي يجب على كل فندق استخدامها كمعيار للعلامة؛ ويظل بإمكان العقارات إضافة أصنافها المحلية.",
  "{n} brand standard": "{n} من معيار العلامة",
  "{n} other group items": "{n} أصناف أخرى للمجموعة",
  "{n} local items": "{n} أصناف محلية",
  "Lock brand standard items": "قفل أصناف معيار العلامة",
  "Capitalise": "رسملة",
  "Expense": "مصروف",
  "Operating Equipment base stock": "المخزون الأساسي لمعدات التشغيل",
  "Straight line": "القسط الثابت",
  "Declining balance": "القسط المتناقص",
  "Loading categories...": "جارٍ تحميل الفئات...",
  "Every item belongs to a category, and each category follows exactly one active book policy version at a time": "ينتمي كل صنف إلى فئة، وتتبع كل فئة إصدارًا نشطًا واحدًا فقط من السياسة الدفترية في كل وقت",
  "(current period {period})": "(الفترة الحالية {period})",
  ". Policies are maintained by finance under Depreciation & Book Policy.": ". تتولى المالية إدارة السياسات ضمن الإهلاك والسياسة الدفترية.",
  "Category": "الفئة",
  "Active policy": "السياسة النشطة",
  "Effective": "السريان",
  "Treatment": "المعالجة",
  "Method / life": "الطريقة / العمر",
  "Threshold": "الحد",
  "Items": "الأصناف",
  "Default for {classes}": "الافتراضي لـ {classes}",
  "Version {n}": "الإصدار {n}",
  "From {date}": "من {date}",
  "to {date}": "إلى {date}",
  "(open-ended)": "(مفتوح المدة)",
  "Next: version {n} from {date}": "التالي: الإصدار {n} من {date}",
  "{n} months": "{n} شهرًا",
  "No active policy yet - ask finance to add one under Depreciation & Book Policy.": "لا توجد سياسة نشطة بعد - اطلب من المالية إضافتها ضمن الإهلاك والسياسة الدفترية.",
  "Category class defaults": "الإعدادات الافتراضية لفئات الأصناف",
  "New items take these defaults; you can change the tracking mode and category on any item.": "تأخذ الأصناف الجديدة هذه الإعدادات الافتراضية؛ ويمكنك تغيير نمط التتبع والفئة لأي صنف.",
  "Category class": "فئة الصنف",
  "Default tracking mode": "نمط التتبع الافتراضي",
  "Default category": "الفئة الافتراضية",
  "Pooled (counted against par)": "مجمّع (يُعد مقابل المستوى المعياري)",
  "Tagged (one by one)": "موسوم (كل قطعة على حدة)",
  "Item no longer available": "الصنف لم يعد متاحًا",
  "Language assist was consulted.": "تمت الاستعانة بالمساعد اللغوي.",
  "Language assist is switched off; rules only.": "المساعد اللغوي متوقف؛ القواعد فقط.",
  "Rules only (no language model configured).": "القواعد فقط (لم يتم إعداد نموذج لغوي).",
  "Found {found} likely duplicate pair; {created} new for review.": "تم العثور على {found} زوج مكرر محتمل؛ {created} جديد للمراجعة.",
  "Found {found} likely duplicate pairs; {created} new for review.": "تم العثور على {found} أزواج مكررة محتملة؛ {created} جديدة للمراجعة.",
  "Merge {duplicate} into {survivor}? Assets, kit lines, schedules and price history move to the survivor.": "دمج {duplicate} في {survivor}؟ تنتقل الأصول وبنود المجموعات والجداول وسجل الأسعار إلى الصنف المُبقى عليه.",
  "Merged into #{sku}. The duplicate is kept as a retired record.": "تم الدمج في #{sku}. يُحتفظ بالمكرر كسجل متقاعد.",
  "Proposal rejected. This pair will not be proposed again.": "تم رفض الاقتراح. لن يُقترح هذا الزوج مرة أخرى.",
  "Duplicate proposals": "اقتراحات المكررات",
  "{n} waiting": "{n} بانتظار القرار",
  "Likely duplicates found by make, model and name in any word order": "مكررات محتملة حسب الصانع والطراز والاسم بأي ترتيب للكلمات",
  ", plus language assist suggestions": "، إضافة إلى اقتراحات المساعد اللغوي",
  ". Nothing merges until you approve.": ". لا يتم أي دمج حتى توافق.",
  "Find duplicates": "البحث عن المكررات",
  "Hide": "إخفاء",
  "Review": "مراجعة",
  "Show": "عرض",
  "Waiting for a decision": "بانتظار قرار",
  "Merged": "مدموج",
  "Rejected": "مرفوض",
  "No longer applicable": "لم يعد منطبقًا",
  "All": "الكل",
  "No proposals waiting. Select Find duplicates to check the catalogue.": "لا توجد اقتراحات منتظرة. اختر البحث عن المكررات لفحص الكتالوج.",
  "Nothing here yet.": "لا شيء هنا بعد.",
  "Keep": "الإبقاء",
  "Merge into it": "الدمج فيه",
  "Match": "التطابق",
  "Found by": "عُثر عليه بواسطة",
  "Decision": "القرار",
  "Shared starter": "أولي مشترك",
  "Merge": "دمج",
  "Not duplicates": "ليست مكررة",
  "Waiting": "بالانتظار",
  "Will be added": "ستُضاف",
  "Already in catalogue": "موجود في الكتالوج",
  "Fix needed": "يحتاج إلى تصحيح",
  "The file must be smaller than 900 KB - split larger catalogues into several files.": "يجب أن يكون حجم الملف أقل من 900 كيلوبايت - قسّم الكتالوجات الكبيرة إلى عدة ملفات.",
  "Import Catalogue from CSV": "استيراد الكتالوج من ملف CSV",
  "Working...": "جارٍ التنفيذ...",
  "Import {n} item": "استيراد {n} صنف",
  "Import {n} items": "استيراد {n} أصناف",
  "Import": "استيراد",
  "Download the template and add one item per row.": "نزّل القالب وأضف صنفًا واحدًا في كل صف.",
  "Download template": "تنزيل القالب",
  "Leave Tracking Mode empty to use the class default: Operating Equipment is counted as pooled stock, every other class is tagged one by one.": "اترك نمط التتبع فارغًا لاستخدام الإعداد الافتراضي للفئة: تُعد معدات التشغيل كمخزون مجمّع، وتُوسم كل الفئات الأخرى قطعةً قطعة.",
  "Choose the file. Nothing is saved until you confirm the preview.": "اختر الملف. لن يُحفظ شيء حتى تؤكد المعاينة.",
  "Add the items to": "إضافة الأصناف إلى",
  "The group catalogue (every property)": "كتالوج المجموعة (كل العقارات)",
  "Only {name} (local items)": "{name} فقط (أصناف محلية)",
  "Catalogue CSV file": "ملف CSV للكتالوج",
  "Checking {file}...": "جارٍ فحص {file}...",
  "row:": "صف:",
  "rows:": "صفوف:",
  "new,": "جديد،",
  "already in the catalogue (skipped),": "موجود مسبقًا في الكتالوج (تم تخطيه)،",
  "with errors.": "بها أخطاء.",
  "Import only the valid rows and leave the {n} row with errors out": "استيراد الصفوف الصالحة فقط واستبعاد {n} صف به أخطاء",
  "Import only the valid rows and leave the {n} rows with errors out": "استيراد الصفوف الصالحة فقط واستبعاد {n} صفوف بها أخطاء",
  "Row": "الصف",
  "Item": "الصنف",
  "Class": "الفئة",
  "Tracking": "التتبع",
  "Std Cost": "التكلفة القياسية",
  "Result": "النتيجة",
  "Keep each supplier's contact details and warranty terms here, then pick the supplier on a catalogue item.": "احفظ بيانات الاتصال وشروط الضمان لكل مورد هنا، ثم اختر المورد في صنف الكتالوج.",
  "Show inactive": "عرض غير النشطين",
  "Add Supplier": "إضافة مورد",
  "Supplier": "المورد",
  "Contact": "جهة الاتصال",
  "Warranty terms": "شروط الضمان",
  "Loading suppliers...": "جارٍ تحميل الموردين...",
  "No suppliers yet.": "لا يوجد موردون بعد.",
  "Choose Add Supplier to record your first supplier and its warranty terms.": "اختر إضافة مورد لتسجيل أول مورد وشروط ضمانه.",
  "Ask your administrator to add your suppliers.": "اطلب من المسؤول إضافة الموردين.",
  "Shared": "مشترك",
  "Inactive": "غير نشط",
  "Not recorded": "غير مسجّل",
  "Edit Supplier": "تعديل المورد",
  "Save Supplier": "حفظ المورد",
  "Supplier name": "اسم المورد",
  "Contact person": "الشخص المسؤول",
  "Email": "البريد الإلكتروني",
  "Phone": "الهاتف",
  "e.g. 24 months parts and labour, on-site within 48 hours": "مثال: 24 شهرًا قطع غيار وعمالة، وحضور في الموقع خلال 48 ساعة",
  "Notes": "ملاحظات",
  "Active (inactive suppliers can no longer be picked on items)": "نشط (لا يمكن اختيار الموردين غير النشطين في الأصناف)",
  "Supplier name is required": "اسم المورد مطلوب",
  "Enter a valid email address": "أدخل بريدًا إلكترونيًا صالحًا",
  "Supplier \"{name}\" updated.": "تم تحديث المورد \"{name}\".",
  "Supplier \"{name}\" added.": "تمت إضافة المورد \"{name}\".",
  "Edit {name}": "تعديل {name}",
  "Housekeeping": "التدبير الفندقي",
  "Engineering": "الهندسة",
  "Front Office": "المكتب الأمامي",
  "Add at least one invoice line": "أضف بند فاتورة واحدًا على الأقل",
  "Enter the invoice total so the lines can be checked against it": "أدخل إجمالي الفاتورة لمطابقة البنود معه",
  "Invoice total mismatch of {diff}: lines add up to {lines} but the invoice total is {total}": "فرق في إجمالي الفاتورة بقيمة {diff}: مجموع البنود {lines} بينما إجمالي الفاتورة {total}",
  "VAT mismatch of {diff}: 5% VAT on the lines is {vat} but the invoice states {stated}": "فرق في ضريبة القيمة المضافة بقيمة {diff}: ضريبة 5% على البنود تساوي {vat} بينما تذكر الفاتورة {stated}",
  "Could not read the file": "تعذّرت قراءة الملف",
  "Fix the highlighted lines before confirming.": "صحّح البنود المميزة قبل التأكيد.",
  "Confirmation is blocked: {issues}": "التأكيد موقوف: {issues}",
  "Enter the supplier before confirming.": "أدخل المورد قبل التأكيد.",
  "Choose the property and storeroom that receives the assets.": "اختر العقار والمخزن الذي يستلم الأصول.",
  "AI Draft Mode": "وضع المسودة بالذكاء الاصطناعي",
  "Manual Draft Mode": "وضع المسودة اليدوي",
  "Draft Catalogue & Asset Records from Supplier Invoice": "صياغة سجلات الكتالوج والأصول من فاتورة المورد",
  "Confirm & Create Master Items": "تأكيد وإنشاء الأصناف الرئيسية",
  "Draft {ref} confirmed": "تم تأكيد المسودة {ref}",
  "{items} new Catalogue Item(s) and {assets} serialized asset(s) were created, awaiting physical tag binding. Cost net of recoverable VAT:": "تم إنشاء {items} صنف/أصناف جديدة في الكتالوج و{assets} أصل/أصول مسلسلة بانتظار ربط الوسوم فعليًا. التكلفة بعد خصم ضريبة القيمة المضافة القابلة للاسترداد:",
  "(VAT {vat}, invoice total {total}).": "(ضريبة القيمة المضافة {vat}، إجمالي الفاتورة {total}).",
  "(new)": "(جديد)",
  "(existing item reused)": "(أُعيد استخدام صنف موجود)",
  "Upload Supplier Invoice (PDF / JPG / PNG)": "تحميل فاتورة المورد (PDF / JPG / PNG)",
  "Supplier invoice": "فاتورة المورد",
  "Loaded:": "تم التحميل:",
  "No invoice uploaded yet - the language assist drafts the lines for you to confirm.": "لم يتم تحميل فاتورة بعد - يصوغ المساعد اللغوي البنود لتؤكدها.",
  "Language assist is switched off for your organisation.": "المساعد اللغوي متوقف لمؤسستك.",
  "Resume an open draft": "استئناف مسودة مفتوحة",
  "Resume an open draft...": "استئناف مسودة مفتوحة...",
  "untitled": "بدون عنوان",
  "({n} lines)": "({n} بنود)",
  "Deterministic Validation Check": "فحص التحقق الحتمي",
  "Invoice Stated Total (AED):": "إجمالي الفاتورة المذكور (درهم):",
  "Extracted Line Total:": "إجمالي البنود المستخرجة:",
  "(Net)": "(صافي)",
  "Stated UAE VAT (5%) (AED):": "ضريبة القيمة المضافة المذكورة (5%) (درهم):",
  "Optional": "اختياري",
  "Recoverable UAE VAT (5%):": "ضريبة القيمة المضافة القابلة للاسترداد (5%):",
  "(Isolated)": "(معزولة)",
  "Balance Check:": "فحص التوازن:",
  "100% Reconciled": "مطابق بنسبة 100%",
  "Waiting for invoice lines": "بانتظار بنود الفاتورة",
  "Unit costs on the invoice include 5% VAT": "تكاليف الوحدة في الفاتورة تشمل ضريبة القيمة المضافة 5%",
  "Language assist is unavailable": "المساعد اللغوي غير متاح",
  "Language assist is switched off": "المساعد اللغوي متوقف",
  "- the deterministic path has the same functions": "- يوفر المسار الحتمي الوظائف نفسها",
  "Download CSV template": "تنزيل قالب CSV",
  "Import filled CSV": "استيراد ملف CSV المعبأ",
  "Filled invoice CSV": "ملف CSV للفاتورة المعبأ",
  "Enter lines manually": "إدخال البنود يدويًا",
  "Invoice No.": "رقم الفاتورة",
  "Extracted Draft Lines (User Confirmation Required)": "بنود المسودة المستخرجة (يلزم تأكيد المستخدم)",
  "Item Name (Make & Model)": "اسم الصنف (الصانع والطراز)",
  "Qty": "الكمية",
  "Unit Cost (AED)": "تكلفة الوحدة (درهم)",
  "Line Total (AED)": "إجمالي البند (درهم)",
  "Status": "الحالة",
  "No draft lines yet.": "لا توجد بنود مسودة بعد.",
  "Item name": "اسم الصنف",
  "Quantity": "الكمية",
  "Unit cost": "تكلفة الوحدة",
  "Draft Line": "بند مسودة",
  "Remove line {n}": "إزالة البند {n}",
  "Add line": "إضافة بند",
  "Discard draft": "تجاهل المسودة",
  "Receiving Property": "العقار المستلم",
  "Storeroom": "المخزن",
  "Custodian Department": "القسم المسؤول عن العهدة",
  "Records remain in draft state until confirmed. Confirming creates active Catalogue Items and draft serialized assets for physical tag binding.": "تبقى السجلات في حالة مسودة حتى التأكيد. ينشئ التأكيد أصنافًا نشطة في الكتالوج وأصولًا مسلسلة كمسودات لربط الوسوم فعليًا.",
  "{m} Mos ({y} Yrs)": "{m} شهرًا ({y} سنوات)",
  "{m} Mos": "{m} شهرًا",
  "Could not read the photo": "تعذّرت قراءة الصورة",
  "{n} item(s) marked as brand standard. Every property uses them as set by the group.": "تم تحديد {n} صنف/أصناف كمعيار للعلامة. تستخدمها كل العقارات كما حددتها المجموعة.",
  "{n} item(s) are no longer brand standard.": "لم يعد {n} صنف/أصناف ضمن معيار العلامة.",
  "Item title is required": "عنوان الصنف مطلوب",
  "Enter a standard cost of zero or more": "أدخل تكلفة قياسية تساوي صفرًا أو أكثر",
  "Enter a replacement cost of zero or more": "أدخل تكلفة استبدال تساوي صفرًا أو أكثر",
  "Photos must be JPEG, PNG or WebP images": "يجب أن تكون الصور بصيغة JPEG أو PNG أو WebP",
  "Useful life must be between 1 and 50 years": "يجب أن يكون العمر الإنتاجي بين 1 و50 سنة",
  "Your own copy of \"{name}\" was created and saved. The shared starter item is unchanged.": "تم إنشاء نسختك الخاصة من \"{name}\" وحفظها. لم يتغير الصنف الأولي المشترك.",
  "Master catalogue item \"{name}\" updated successfully.": "تم تحديث صنف الكتالوج الرئيسي \"{name}\" بنجاح.",
  "Master catalogue item \"{name}\" created as #{sku}, but it matches #{dupSku} ({dupName}) with {similarity}% similarity. Review the duplicate warning and merge if they are the same item.": "تم إنشاء صنف الكتالوج الرئيسي \"{name}\" برقم #{sku}، لكنه يطابق #{dupSku} ({dupName}) بنسبة تشابه {similarity}%. راجع تحذير التكرار وادمجهما إن كانا الصنف نفسه.",
  "Master catalogue item \"{name}\" created successfully as #{sku}{source}.": "تم إنشاء صنف الكتالوج الرئيسي \"{name}\" بنجاح برقم #{sku}{source}.",
  "\"{name}\" was saved, but the photo was not: {error}": "تم حفظ \"{name}\" لكن لم تُحفظ الصورة: {error}",
  "Fix the highlighted cost or useful life values before deploying.": "صحّح قيم التكلفة أو العمر الإنتاجي المميزة قبل النشر.",
  "{label} Starter Pack deployed! Seeded {created} standard hospitality equipment items across 7 category classes with IAS 16 useful life baselines ({skipped} already in the catalogue, {kitBindings} Room Kit blueprint bindings created).": "تم نشر الحزمة الأولية {label}! أُضيف {created} صنفًا قياسيًا من معدات الضيافة عبر 7 فئات بأعمار إنتاجية أساسية وفق IAS 16 ({skipped} موجودة مسبقًا في الكتالوج، وأُنشئ {kitBindings} ربطًا لمخططات مجموعات الغرف).",
  "{n} asset": "{n} أصل",
  "{n} assets": "{n} أصول",
  "{n} room kit line": "{n} بند مجموعة غرف",
  "{n} room kit lines": "{n} بنود مجموعات غرف",
  "{n} other linked record (schedules, replacements, invoice lines)": "{n} سجل مرتبط آخر (جداول، استبدالات، بنود فواتير)",
  "{n} other linked records (schedules, replacements, invoice lines)": "{n} سجلات مرتبطة أخرى (جداول، استبدالات، بنود فواتير)",
  "{n} price history entry": "{n} قيد في سجل الأسعار",
  "{n} price history entries": "{n} قيود في سجل الأسعار",
  "Items merged successfully. Survivor master SKU: #{sku}. Moved to the survivor: {moved}. The duplicate is kept as a retired record.": "تم دمج الأصناف بنجاح. الصنف الرئيسي المُبقى عليه: #{sku}. نُقل إليه: {moved}. يُحتفظ بالمكرر كسجل متقاعد.",
  "Governed Extraction Assist enabled. Private-server model produces draft records for user confirmation.": "تم تفعيل مساعد الاستخراج المحكوم. ينتج نموذج الخادم الخاص سجلات مسودة لتأكيد المستخدم.",
  "Governed Extraction Assist disabled. Manual forms and CSV bulk templates remain 100% active with zero loss of functionality.": "تم تعطيل مساعد الاستخراج المحكوم. تظل النماذج اليدوية وقوالب CSV الجماعية فعّالة بالكامل دون فقدان أي وظيفة.",
  "Catalogue": "الكتالوج",
  "Your organisation’s catalogue: shared starter items plus your own. Editing a starter item saves your own copy; the shared original never changes.": "كتالوج مؤسستك: الأصناف الأولية المشتركة إضافة إلى أصنافك. تعديل صنف أولي يحفظ نسختك الخاصة؛ ولا يتغير الأصل المشترك أبدًا.",
  "The shared starter catalogue every customer starts from, across 7 category classes, with starter packs, duplicate merging and invoice extraction.": "الكتالوج الأولي المشترك الذي يبدأ منه كل عميل، عبر 7 فئات، مع الحزم الأولية ودمج المكررات واستخراج الفواتير.",
  "Only a customer administrator can switch the language assist": "يمكن لمسؤول العميل فقط تشغيل المساعد اللغوي أو إيقافه",
  "Governed Extraction Assist": "مساعد الاستخراج المحكوم",
  "Extract Invoice": "استخراج فاتورة",
  "Import CSV": "استيراد CSV",
  "Governed Language Assist Active:": "المساعد اللغوي المحكوم نشط:",
  "Invoice and photo extractions produce": "تنتج عمليات استخراج الفواتير والصور",
  "draft records only": "سجلات مسودة فقط",
  ". User confirmation is mandatory before any master item or asset is created. If disabled, manual forms and CSV bulk templates remain 100% operational with zero feature loss.": ". تأكيد المستخدم إلزامي قبل إنشاء أي صنف رئيسي أو أصل. وعند التعطيل، تظل النماذج اليدوية وقوالب CSV الجماعية تعمل بالكامل دون فقدان أي ميزة.",
  "Private Server Runtime": "تشغيل على خادم خاص",
  "Potential Duplicate SKUs Detected (Similarity Match:": "تم اكتشاف رموز أصناف مكررة محتملة (نسبة التشابه:",
  "and": "و",
  "share identical attributes.": "يتشاركان خصائص متطابقة.",
  "({n} more pairs detected)": "(تم اكتشاف {n} أزواج أخرى)",
  "({n} more pair detected)": "(تم اكتشاف {n} زوج آخر)",
  "Categories & Book Policy": "الفئات والسياسة الدفترية",
  "Suppliers": "الموردون",
  "Search catalogue": "البحث في الكتالوج",
  "Filter by category class": "التصفية حسب فئة الصنف",
  "Filter by library": "التصفية حسب المكتبة",
  "All items": "كل الأصناف",
  "Brand standard": "معيار العلامة",
  "Group catalogue": "كتالوج المجموعة",
  "Local items": "الأصناف المحلية",
  "Show the catalogue as one property sees it": "عرض الكتالوج كما يراه عقار واحد",
  "Every property": "كل العقارات",
  "As {name} sees it": "كما يراه {name}",
  "{n} selected": "{n} محدد",
  "Mark as brand standard": "تحديد كمعيار للعلامة",
  "Remove from brand standard": "إزالة من معيار العلامة",
  "Clear": "مسح",
  "No local items yet. Use Add Item and choose \"Only this property\" to add an item one property needs that the group catalogue does not have.": "لا توجد أصناف محلية بعد. استخدم إضافة صنف واختر \"هذا العقار فقط\" لإضافة صنف يحتاجه عقار واحد ولا يتوفر في كتالوج المجموعة.",
  "No brand standard items yet. Select group items and mark them as brand standard so every property uses them as set by the group.": "لا توجد أصناف ضمن معيار العلامة بعد. حدد أصناف المجموعة واجعلها معيارًا للعلامة لتستخدمها كل العقارات كما حددتها المجموعة.",
  "The catalogue is empty. Add an item, import a CSV or deploy a starter pack to begin.": "الكتالوج فارغ. أضف صنفًا أو استورد ملف CSV أو انشر حزمة أولية للبدء.",
  "The catalogue is empty. Deploy a starter pack to begin.": "الكتالوج فارغ. انشر حزمة أولية للبدء.",
  "Select {name}": "تحديد {name}",
  "Starter": "أولي",
  "Customised": "مخصص",
  "Own": "خاص",
  "Only this property sees this item": "هذا العقار فقط يرى هذا الصنف",
  "Part of the brand standard set by the group": "جزء من معيار العلامة الذي حددته المجموعة",
  "Shared by every property of the group": "مشترك بين كل عقارات المجموعة",
  "Supplier:": "المورد:",
  "Brand standard: only your group administrators can change this item": "معيار العلامة: لا يمكن تعديل هذا الصنف إلا من قِبل مسؤولي مجموعتك",
  "Locked brand standard item": "صنف معيار علامة مقفل",
  "Remove from the brand standard": "إزالة من معيار العلامة",
  "Customise: saves your own copy of this starter item": "تخصيص: يحفظ نسختك الخاصة من هذا الصنف الأولي",
  "Edit item": "تعديل الصنف",
  "Customise": "تخصيص",
  "Edit": "تعديل",
  "Showing {shown} of {total} items. Refine your search to narrow the list.": "عرض {shown} من {total} صنف. حسّن بحثك لتضييق القائمة.",
  "Catalogue import complete: {n} item(s) added{skipped}.": "اكتمل استيراد الكتالوج: أُضيف {n} صنف/أصناف{skipped}.",
  ", {n} already in the catalogue were skipped": "، وتم تخطي {n} موجودة مسبقًا في الكتالوج",
  "Invoice draft {ref} confirmed: {n} asset(s) created at cost net of VAT ({net}).": "تم تأكيد مسودة الفاتورة {ref}: أُنشئ {n} أصل/أصول بتكلفة صافية من ضريبة القيمة المضافة ({net}).",
  "Customise Starter Item": "تخصيص الصنف الأولي",
  "Who uses this item": "من يستخدم هذا الصنف",
  "Every property (group catalogue)": "كل العقارات (كتالوج المجموعة)",
  "Only {name} (local item)": "{name} فقط (صنف محلي)",
  "A local item is visible only to that property. Use it for things the group catalogue does not cover.": "يظهر الصنف المحلي لذلك العقار فقط. استخدمه لما لا يغطيه كتالوج المجموعة.",
  "This is a shared starter item. Saving creates your organisation's own copy with the same SKU; the starter item stays unchanged for everyone else.": "هذا صنف أولي مشترك. يؤدي الحفظ إلى إنشاء نسخة خاصة بمؤسستك بنفس رمز الصنف؛ ويبقى الصنف الأولي دون تغيير للجميع.",
  "Photo Suggestion Assist:": "مساعد اقتراح الصور:",
  "Photo suggests make, category class, and benchmark replacement cost in AED.": "تقترح الصورة الصانع وفئة الصنف وتكلفة الاستبدال المرجعية بالدرهم.",
  "Analysing photo...": "جارٍ تحليل الصورة...",
  " Use the catalogue search or enter the item manually.": " استخدم البحث في الكتالوج أو أدخل الصنف يدويًا.",
  "Suggested category:": "الفئة المقترحة:",
  "({n}% match)": "(تطابق {n}%)",
  "Accept": "قبول",
  "Accept category": "قبول الفئة",
  "Dismiss": "تجاهل",
  "Catalogue Search:": "البحث في الكتالوج:",
  "Search existing catalogue items...": "ابحث في أصناف الكتالوج الحالية...",
  "Search the catalogue": "البحث في الكتالوج",
  "Language assist is off - find a similar item and reuse its definition, or enter the item below.": "المساعد اللغوي متوقف - ابحث عن صنف مشابه وأعد استخدام تعريفه، أو أدخل الصنف أدناه.",
  "Use": "استخدام",
  "Item Title": "عنوان الصنف",
  "e.g. Minibar Glass Door 40L": "مثال: ميني بار بباب زجاجي 40 لتر",
  "Pooled (Bulk Stock)": "مجمّع (مخزون بالجملة)",
  "Class default:": "الافتراضي للفئة:",
  " (overridden for this item)": " (تم تجاوزه لهذا الصنف)",
  "Category (book policy)": "الفئة (السياسة الدفترية)",
  "Class default ({category})": "الافتراضي للفئة ({category})",
  "No supplier": "بدون مورد",
  "Current supplier": "المورد الحالي",
  "Make": "الصانع",
  "Model": "الطراز",
  "Specification": "المواصفات",
  "Useful Life (Years)": "العمر الإنتاجي (سنوات)",
  "Item photo": "صورة الصنف",
  "JPEG, PNG or WebP.": "JPEG أو PNG أو WebP.",
  "Choosing a file replaces the current photo.": "اختيار ملف يستبدل الصورة الحالية.",
  "Shown in the catalogue list.": "تظهر في قائمة الكتالوج.",
  "(defaults to the standard cost)": "(افتراضيًا التكلفة القياسية)",
  "Deploy Hospitality Starter Pack": "نشر حزمة الضيافة الأولية",
  "Deploy Starter Pack": "نشر الحزمة الأولية",
  "Pre-seeds standard international hospitality equipment baselines across guestrooms, banquets, and housekeeping.": "يضيف مسبقًا أساسيات معدات الضيافة الدولية القياسية للغرف والمآدب والتدبير الفندقي.",
  "Select Property Profile": "اختر ملف العقار",
  "({n}+ Curated Items)": "({n}+ صنف منتقى)",
  "Loading pack preview...": "جارٍ تحميل معاينة الحزمة...",
  "items in this pack,": "صنف في هذه الحزمة،",
  "will be added to the master catalogue": "ستُضاف إلى الكتالوج الرئيسي",
  "({n} already exist and are skipped)": "({n} موجودة مسبقًا وسيتم تخطيها)",
  ". Adjust standard cost or useful life below before confirming.": ". عدّل التكلفة القياسية أو العمر الإنتاجي أدناه قبل التأكيد.",
  "Std Cost (AED)": "التكلفة القياسية (درهم)",
  "Useful Life (Yrs)": "العمر الإنتاجي (سنوات)",
  "In catalogue": "في الكتالوج",
  "Standard cost for {name}": "التكلفة القياسية لـ {name}",
  "Useful life in years for {name}": "العمر الإنتاجي بالسنوات لـ {name}",
  "Merge Duplicate Master Items": "دمج الأصناف الرئيسية المكررة",
  "Merging...": "جارٍ الدمج...",
  "Confirm Merge": "تأكيد الدمج",
  "Assets linked to the duplicate, its room kit lines, maintenance schedules, replacement and invoice lines and its price history move to the survivor. The duplicate stays as a retired record.": "تنتقل الأصول المرتبطة بالمكرر وبنود مجموعات الغرف وجداول الصيانة وبنود الاستبدال والفواتير وسجل الأسعار إلى الصنف المُبقى عليه. يبقى المكرر كسجل متقاعد.",
  " The survivor is a shared starter item, so your own copy of it is created first and receives everything.": " الصنف المُبقى عليه صنف أولي مشترك، لذا تُنشأ نسختك الخاصة منه أولًا وتستلم كل شيء.",
  "Detected Pair": "الزوج المكتشف",
  "#{dup} into #{survivor}": "#{dup} في #{survivor}",
  "Survivor Master SKU": "الصنف الرئيسي المُبقى عليه",
  "Deprecated Duplicate SKU": "رمز الصنف المكرر الملغى",
  "Stock Point tags": "وسوم نقاط المخزون",
  "Stick a tag on each Stock Point so a scan opens its stock and count sheet.": "ألصق وسمًا على كل نقطة مخزون ليفتح المسح مخزونها وورقة العد الخاصة بها.",
  "Stock Point": "نقطة المخزون",
  "You scanned the tag of": "لقد مسحت وسم",
  ". Its stock is listed above; count it from the blind count screen.": ". مخزونها معروض أعلاه؛ قم بعدّه من شاشة العد الأعمى.",
  "Save a Stock Point first, then print its tag here.": "احفظ نقطة مخزون أولًا، ثم اطبع وسمها هنا.",
  "Clean in store": "نظيف في المخزن",
  "In rooms": "في الغرف",
  "At laundry": "في المغسلة",
  "Choose the linen item": "اختر صنف البياضات",
  "Enter a quantity of at least 1": "أدخل كمية لا تقل عن 1",
  "{qty} written off as {ref}{pending}.": "تم شطب {qty} بالمرجع {ref}{pending}.",
  "(awaiting department head approval)": "(بانتظار موافقة رئيس القسم)",
  "{action}: {qty} {item}. Clean in store is now {clean}.": "{action}: {qty} {item}. النظيف في المخزن الآن {clean}.",
  "Linen laundry cycle": "دورة غسيل البياضات",
  "Where each linen pool is: clean in store, in rooms or out at the laundry. Damaged pieces are written off as breakage.": "مكان كل مجموعة بياضات: نظيفة في المخزن أو في الغرف أو في المغسلة. تُشطب القطع التالفة ككسر.",
  "Out at laundry": "خارج في المغسلة",
  "Overdue returns": "مرتجعات متأخرة",
  "Loss rate ({n} days)": "معدل الفقد ({n} يومًا)",
  "No linen is held at a Stock Point yet. Receive linen into a Stock Point (category Linen) and it appears here.": "لا توجد بياضات في أي نقطة مخزون بعد. استلم البياضات في نقطة مخزون (فئة البياضات) لتظهر هنا.",
  "Pool": "المجموعة",
  "Overdue": "متأخر",
  "Loss rate": "معدل الفقد",
  "{n} fewer on the book than in rooms and at the laundry - count this item": "{n} أقل في الدفاتر مما في الغرف والمغسلة - قم بعدّ هذا الصنف",
  "since {date}": "منذ {date}",
  "Linen item": "صنف البياضات",
  "Choose…": "اختر…",
  "What happened": "ما الذي حدث",
  "From": "من",
  "Expected back": "موعد العودة المتوقع",
  "Blank = in 2 days": "فارغ = خلال يومين",
  "Reason": "السبب",
  "Laundry tear / stained": "تمزق في المغسلة / بقع",
  "Guest damage": "ضرر من النزيل",
  "Lost in service": "فُقد أثناء الخدمة",
  "Unaccounted": "غير محسوب",
  "Record": "تسجيل",
  "Choose the item": "اختر الصنف",
  "Enter the EPC prefix": "أدخل بادئة EPC",
  "Paste at least one EPC": "الصق رمز EPC واحدًا على الأقل",
  "{n} added{mapped}.": "تمت إضافة {n}{mapped}.",
  ", {n} already mapped": "، و{n} مربوطة مسبقًا",
  "RFID tags for linen and pooled items": "وسوم RFID للبياضات والأصناف المجمّعة",
  "Tell AssetOS which RFID chips belong to which item, then import handheld reader files as counts from the blind count screen.": "حدّد لـ AssetOS أي شرائح RFID تخص أي صنف، ثم استورد ملفات القارئ المحمول كعدّ من شاشة العد الأعمى.",
  "EPC starts with": "يبدأ EPC بـ",
  "Exact EPCs": "رموز EPC مطابقة",
  "EPC prefix": "بادئة EPC",
  "EPCs (one per line)": "رموز EPC (واحد في كل سطر)",
  "e.g. 3034257BF7194E40": "مثال: 3034257BF7194E40",
  "Add": "إضافة",
  "No RFID chips are mapped yet. Choose an item and enter the EPC prefix printed by your linen supplier, or paste the EPCs of individual pieces.": "لا توجد شرائح RFID مربوطة بعد. اختر صنفًا وأدخل بادئة EPC المطبوعة من مورد البياضات، أو الصق رموز EPC للقطع المفردة.",
  "Starts with": "يبدأ بـ",
  "Exact": "مطابق",
  "Remove {epc}": "إزالة {epc}",
  "Remove": "إزالة",
  "Linen": "البياضات",
  "Linen Laundry": "غسيل البياضات",
  "Where each linen pool is and what is overdue back from the laundry. Record sends, returns and damage below.": "مكان كل مجموعة بياضات وما تأخر عودته من المغسلة. سجّل الإرسال والإرجاع والتلف أدناه.",
  "Where each linen pool is and what is overdue back from the laundry. Stores record the moves; this view is read-only.": "مكان كل مجموعة بياضات وما تأخر عودته من المغسلة. يسجل المخزن الحركات؛ هذا العرض للقراءة فقط.",
  "Property": "العقار",
  "No properties yet. Add a property under Locations & Hierarchy first.": "لا توجد عقارات بعد. أضف عقارًا ضمن المواقع والتسلسل الهرمي أولًا.",
  "Pick the stock line": "اختر بند المخزون",
  "Pick the issue being returned": "اختر الصرف الذي يتم إرجاعه",
  "Enter a whole quantity of at least 1": "أدخل كمية صحيحة لا تقل عن 1",
  "Choose a person, a department or a location": "اختر شخصًا أو قسمًا أو موقعًا",
  "Pick the receiving Stock Point": "اختر نقطة المخزون المستلمة",
  "Issued {qty} {item}. {left} left at {stockPoint}.": "تم صرف {qty} {item}. يتبقى {left} في {stockPoint}.",
  "Returned {qty} {item}. {outstanding} still out on that issue.": "تم إرجاع {qty} {item}. لا يزال {outstanding} خارجًا على ذلك الصرف.",
  "Transferred {qty} from {from} (now {fromOnHand}) to {to} (now {toOnHand}).": "تم نقل {qty} من {from} (الآن {fromOnHand}) إلى {to} (الآن {toOnHand}).",
  "Stock Moves": "حركات المخزون",
  "Issue, return and transfer pooled stock. Every change to a book quantity is recorded below with the balance after it.": "اصرف المخزون المجمّع وأرجعه وانقله. يُسجَّل أدناه كل تغيير في الكمية الدفترية مع الرصيد بعده.",
  "Move type": "نوع الحركة",
  "Issue": "صرف",
  "Return": "إرجاع",
  "Transfer between Stock Points": "نقل بين نقاط المخزون",
  "Stock line": "بند المخزون",
  "Select stock...": "اختر المخزون...",
  "Issue being returned": "الصرف الذي يتم إرجاعه",
  "Select an issue...": "اختر صرفًا...",
  "Nothing is out on issue": "لا يوجد شيء مصروف حاليًا",
  "{n} out with {who}": "{n} لدى {who}",
  "(due {date})": "(مستحق في {date})",
  "{n} on hand": "{n} متوفر",
  "Person": "الشخص",
  "No named person": "بدون شخص محدد",
  "Department": "القسم",
  "None": "لا شيء",
  "Location": "الموقع",
  "Due back (optional)": "موعد الإرجاع (اختياري)",
  "To Stock Point": "إلى نقطة المخزون",
  "Select...": "اختر...",
  "Note (optional)": "ملاحظة (اختياري)",
  "Issue stock": "صرف المخزون",
  "Record return": "تسجيل الإرجاع",
  "Transfer stock": "نقل المخزون",
  "When": "التاريخ",
  "Move": "الحركة",
  "Balance": "الرصيد",
  "Custodian / reference": "العهدة / المرجع",
  "due {date}": "مستحق في {date}",
  "No stock moves yet. Receipts, issues, returns, transfers, breakage and count adjustments will be listed here.": "لا توجد حركات مخزون بعد. ستظهر هنا عمليات الاستلام والصرف والإرجاع والنقل والكسر وتسويات العد.",
  "Stock refreshed.": "تم تحديث المخزون.",
  "Select a stock point": "اختر نقطة مخزون",
  "Select a stock item": "اختر صنف مخزون",
  "Enter a whole number of at least 1": "أدخل عددًا صحيحًا لا يقل عن 1",
  "Must be greater than zero": "يجب أن يكون أكبر من صفر",
  "Enter a whole number, zero or more": "أدخل عددًا صحيحًا، صفرًا أو أكثر",
  "Calculated par must be at least 1 unit": "يجب ألا يقل المستوى المعياري المحسوب عن وحدة واحدة",
  "Calculated par level updated successfully: {item} at {stockPoint} is now {par} {unit}.": "تم تحديث المستوى المعياري المحسوب بنجاح: {item} في {stockPoint} أصبح {par} {unit}.",
  "Stock point name is required": "اسم نقطة المخزون مطلوب",
  "Select a location node": "اختر عقدة موقع",
  "Stock point saved successfully: {name} ({code}).": "تم حفظ نقطة المخزون بنجاح: {name} ({code}).",
  "Pooled Stock": "المخزون المجمّع",
  "Stock Points & Par Management": "نقاط المخزون وإدارة المستوى المعياري",
  "Configure stock points, compute par levels and monitor replenishment buffers.": "اضبط نقاط المخزون واحسب المستويات المعيارية وراقب هوامش إعادة التزويد.",
  "Refresh Stock": "تحديث المخزون",
  "Loading stock points…": "جارٍ تحميل نقاط المخزون…",
  "Calculate Par Level": "حساب المستوى المعياري",
  "Under-Par alert: {item} at {stockPoint}": "تنبيه دون المستوى المعياري: {item} في {stockPoint}",
  "On-hand": "المتوفر",
  "against a par of": "مقابل مستوى معياري قدره",
  "— par deficit": "— عجز المستوى المعياري",
  "Replenishment recommendation: reorder": "توصية إعادة التزويد: أعد طلب",
  "(Par − counted quantity).": "(المستوى المعياري − الكمية المعدودة).",
  "{n} SKU is below the alert level.": "{n} صنف دون مستوى التنبيه.",
  "{n} SKUs are below the alert level.": "{n} أصناف دون مستوى التنبيه.",
  "Largest shortfall: {item} at {stockPoint} — suggested reorder {qty} {unit}.": "أكبر نقص: {item} في {stockPoint} — إعادة الطلب المقترحة {qty} {unit}.",
  "Active Stock Points": "نقاط المخزون النشطة",
  "Across {n} Wings & Floors": "عبر {n} أجنحة وطوابق",
  "Total Par Base Units": "إجمالي الوحدات المعيارية الأساسية",
  "{n} SKU below par": "{n} صنف دون المستوى المعياري",
  "{n} SKUs below par": "{n} أصناف دون المستوى المعياري",
  "Fully provisioned": "مجهز بالكامل",
  "No par levels set yet": "لم تُحدد مستويات معيارية بعد",
  "Under-Par SKUs": "أصناف دون المستوى المعياري",
  "Requires replenishment": "يتطلب إعادة تزويد",
  "None below alert level": "لا شيء دون مستوى التنبيه",
  "Default Par Multiplier": "المعامل المعياري الافتراضي",
  "Applied to new par calculations": "يُطبق على حسابات المستوى المعياري الجديدة",
  "No stock points configured yet": "لم تُضبط نقاط مخزون بعد",
  "Pooled Inventory Stock Points": "نقاط مخزون الجرد المجمّع",
  "Hotel Property": "العقار الفندقي",
  "Hotel Property: {name} ({code})": "العقار الفندقي: {name} ({code})",
  "Search item or stock point...": "ابحث عن صنف أو نقطة مخزون...",
  "Save Stock Point": "حفظ نقطة المخزون",
  "Stock Point Location": "موقع نقطة المخزون",
  "Item Name": "اسم الصنف",
  "Par Level": "المستوى المعياري",
  "Current On-Hand": "المتوفر الحالي",
  "UoM": "وحدة القياس",
  "Reorder Requisition": "طلب إعادة توريد",
  "Reorder {item}": "إعادة طلب {item}",
  "Recalculate par level": "إعادة حساب المستوى المعياري",
  "Recalculate par for {item}": "إعادة حساب المستوى المعياري لـ {item}",
  "No pooled stock lines at stock points match your filters. Save a stock point, then use Calculate Par Level to set its first item.": "لا توجد بنود مخزون مجمّع في نقاط المخزون تطابق عوامل التصفية. احفظ نقطة مخزون، ثم استخدم حساب المستوى المعياري لتعيين أول صنف لها.",
  "No lines": "لا توجد بنود",
  "Showing {from}–{to} of {total}": "عرض {from}–{to} من {total}",
  "Previous": "السابق",
  "Next": "التالي",
  "Par Level Calculator": "حاسبة المستوى المعياري",
  "Applying…": "جارٍ التطبيق…",
  "Apply to Stock Point": "تطبيق على نقطة المخزون",
  "Formula:": "المعادلة:",
  "Par = Total Locations × Units Per Room × Multiplier": "المستوى المعياري = إجمالي المواقع × الوحدات لكل غرفة × المعامل",
  "Select a stock point…": "اختر نقطة مخزون…",
  "Target Stock Item": "صنف المخزون المستهدف",
  "Select an item…": "اختر صنفًا…",
  "Total Rooms": "إجمالي الغرف",
  "Units / Room": "وحدات / غرفة",
  "Multiplier": "المعامل",
  "Current On-Hand Quantity": "الكمية المتوفرة الحالية",
  "Leave blank to keep the recorded quantity": "اتركه فارغًا للإبقاء على الكمية المسجلة",
  "Calculated Par Requirement": "المتطلب المعياري المحسوب",
  "Units": "وحدات",
  "Recommended Reorder Alert Threshold:": "حد تنبيه إعادة الطلب الموصى به:",
  "{n} Units ({percent}%)": "{n} وحدة ({percent}%)",
  "Under par: deficit {n}, suggested reorder {n} units": "دون المستوى المعياري: عجز {n}، إعادة الطلب المقترحة {n} وحدة",
  "On-hand meets the alert level": "المتوفر يلبي مستوى التنبيه",
  "Saving…": "جارٍ الحفظ…",
  "Stock Point Name": "اسم نقطة المخزون",
  "e.g. Floor 3 Housekeeping Pantry": "مثال: مخزن التدبير الفندقي في الطابق 3",
  "Location Node": "عقدة الموقع",
  "Select a location…": "اختر موقعًا…",
  "Custodian Role": "دور المسؤول عن العهدة",
  "Read the NFC tag with the phone or type its chip ID": "اقرأ وسم NFC بالهاتف أو اكتب معرّف الشريحة",
  "NFC tag registered as {code}. Bind it to an asset, a location or a Stock Point.": "تم تسجيل وسم NFC برمز {code}. اربطه بأصل أو موقع أو نقطة مخزون.",
  "Register NFC Tag": "تسجيل وسم NFC",
  "Chip ID, e.g. 04:A2:3B:4C:5D:6E:80": "معرّف الشريحة، مثال: 04:A2:3B:4C:5D:6E:80",
  "NFC chip ID": "معرّف شريحة NFC",
  "Read with phone": "القراءة بالهاتف",
  "Register": "تسجيل",
  "QR Code (Opaque ULID URL) + Printed Short Code": "رمز QR (رابط ULID مُعمّى) + رمز قصير مطبوع",
  "Code 128 Linear Barcode + Printed Short Code": "باركود خطي Code 128 + رمز قصير مطبوع",
  "Batch quantity must be a whole number of at least 1": "يجب أن تكون كمية الدفعة عددًا صحيحًا لا يقل عن 1",
  "Batch quantity cannot exceed {max}": "لا يمكن أن تتجاوز كمية الدفعة {max}",
  "Generated {n} unique collision-proof ULID tags with short codes in unassigned state.": "تم إنشاء {n} وسمًا فريدًا من نوع ULID غير قابل للتصادم مع رموز قصيرة بحالة غير مخصصة.",
  "Generate a tag batch first, then print its labels.": "أنشئ دفعة وسوم أولًا، ثم اطبع ملصقاتها.",
  "Choose why the tag is being unbound": "اختر سبب فك ربط الوسم",
  "Add a note explaining the reason": "أضف ملاحظة توضح السبب",
  "Tag {code} unbound from {asset} and retired.": "تم فك ربط الوسم {code} من {asset} وإيقافه.",
  "Tag {code} unbound from {asset}; it can be bound again.": "تم فك ربط الوسم {code} من {asset}؛ ويمكن ربطه مجددًا.",
  "Choose the asset to bind this tag to": "اختر الأصل لربط هذا الوسم به",
  "Choose why the tag is moving to another asset": "اختر سبب نقل الوسم إلى أصل آخر",
  "Tag {code} moved from {from} to {to}.": "تم نقل الوسم {code} من {from} إلى {to}.",
  "Tag {code} bound to {asset}.": "تم ربط الوسم {code} بـ {asset}.",
  "Tag Studio": "استوديو الوسوم",
  "Tag Generation & Binding Console": "وحدة إنشاء الوسوم وربطها",
  "Generate durable asset tags with random opaque ULID payloads, manage printed short codes, and control the tag binding lifecycle.": "أنشئ وسوم أصول متينة بحمولات ULID عشوائية مُعمّاة، وأدر الرموز القصيرة المطبوعة، وتحكم في دورة حياة ربط الوسوم.",
  "Print QR Labels": "طباعة ملصقات QR",
  "Generate Tag Batch": "إنشاء دفعة وسوم",
  "Opaque ULID Payload Architecture": "بنية حمولة ULID المُعمّاة",
  "Each tag encodes a random 128-bit ULID inside an asset verification URL, plus a short code for manual entry, so tag numbers cannot be guessed in sequence.": "يرمّز كل وسم معرّف ULID عشوائيًا بطول 128 بت داخل رابط التحقق من الأصل، إضافة إلى رمز قصير للإدخال اليدوي، فلا يمكن تخمين أرقام الوسوم بالتسلسل.",
  "{n} tag issued · {bound} bound": "{n} وسم صادر · {bound} مربوط",
  "{n} tags issued · {bound} bound": "{n} وسوم صادرة · {bound} مربوطة",
  "Asset Tag Registry & Lifecycle": "سجل وسوم الأصول ودورة حياتها",
  "Short code or ULID": "الرمز القصير أو ULID",
  "Search short code or ULID": "البحث بالرمز القصير أو ULID",
  "Filter by lifecycle state": "التصفية حسب حالة دورة الحياة",
  "All States": "كل الحالات",
  "Bound (In Service)": "مربوط (في الخدمة)",
  "Unassigned (Ready)": "غير مخصص (جاهز)",
  "Retired / Defective": "موقوف / معيب",
  "Short Code": "الرمز القصير",
  "Tag Payload (ULID)": "حمولة الوسم (ULID)",
  "Bound Fixed Asset": "الأصل الثابت المربوط",
  "Property & Room Location": "العقار وموقع الغرفة",
  "Condition": "الحالة الفنية",
  "Lifecycle Action": "إجراء دورة الحياة",
  "NFC chip": "شريحة NFC",
  "{place} tag": "وسم {place}",
  "Serial: {serial}": "الرقم التسلسلي: {serial}",
  "Retired Tag": "وسم موقوف",
  "Unassigned Tag": "وسم غير مخصص",
  "Printed Roll #B{batch}": "لفة مطبوعة #B{batch}",
  "Unbound": "غير مربوط",
  "Not yet bound": "لم يُربط بعد",
  "Retired - cannot be rebound": "موقوف - لا يمكن إعادة ربطه",
  "Manage on the registry screen": "الإدارة من شاشة السجل",
  "Manage on the Stock Points screen": "الإدارة من شاشة نقاط المخزون",
  "In service": "في الخدمة",
  "Awaiting first-scan walk": "بانتظار جولة المسح الأول",
  "Move tag {code} to another asset": "نقل الوسم {code} إلى أصل آخر",
  "Unbind tag {code}": "فك ربط الوسم {code}",
  "Unbind": "فك الربط",
  "Bind tag {code} to an asset": "ربط الوسم {code} بأصل",
  "Bind to Asset": "ربط بأصل",
  "No tags match your search.": "لا توجد وسوم تطابق بحثك.",
  "No tags issued yet. Generate a tag batch to print labels.": "لم تصدر وسوم بعد. أنشئ دفعة وسوم لطباعة الملصقات.",
  "Showing {from}-{to} of {total} tags": "عرض {from}-{to} من {total} وسم",
  "Generate Asset Tag Batch": "إنشاء دفعة وسوم أصول",
  "Batch Tag Quantity": "كمية وسوم الدفعة",
  "Symbology Format": "صيغة الترميز",
  "Label Stock Specification": "مواصفات ورق الملصقات",
  "Unbind tag": "فك ربط الوسم",
  "Currently on": "حاليًا على",
  ". A damaged label or a retired asset retires the tag for good; otherwise the tag goes back to the pool and can be bound again.": ". يؤدي الملصق التالف أو الأصل الموقوف إلى إيقاف الوسم نهائيًا؛ وإلا يعود الوسم إلى المخزون ويمكن ربطه مجددًا.",
  "Choose a reason…": "اختر سببًا…",
  " (retires the tag)": " (يوقف الوسم)",
  "Note": "ملاحظة",
  "(required)": "(مطلوب)",
  "(optional)": "(اختياري)",
  "Bind tag {code}": "ربط الوسم {code}",
  "Move tag": "نقل الوسم",
  "Bind tag": "ربط الوسم",
  ". Moving the tag takes it off that asset and records the move on both assets' timelines.": ". نقل الوسم يزيله عن ذلك الأصل ويسجل النقل في السجل الزمني للأصلين.",
  "Asset": "الأصل",
  "Search asset number, name or serial": "ابحث برقم الأصل أو اسمه أو رقمه التسلسلي",
  "SN {serial}": "الرقم التسلسلي {serial}",
  "already has tag {code}": "لديه الوسم {code} بالفعل",
  " · current asset": " · الأصل الحالي",
  "No assets match. Register the asset in Inwarding & Tagging first.": "لا توجد أصول مطابقة. سجّل الأصل في الاستلام والوسم أولًا.",
  "Reason for the move": "سبب النقل",
  "Label Print Preview - Batch #{id}": "معاينة طباعة الملصقات - الدفعة #{id}",
  "Download PDF": "تنزيل PDF",
  "Label print sheet for batch {id}": "ورقة طباعة الملصقات للدفعة {id}",
};
